import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../../redux/actions/index';
import * as enums from '../../utils/enums';
import moment from 'moment-timezone';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import _orderBy from 'lodash/orderBy';
import _isEmpty from 'lodash/isEmpty';
import InventoryUtils from '../../utils/inventory-utils';
import Select from 'react-select';
import ReactTable from 'react-table';
import getInventoryTableColumns from './setup-table-settings';
import { TravcoDateRangePicker } from 'travco-date-range-picker';
import { TravcoDaySelector } from 'travco-day-selector';
import { TravcoHotelAutocomplete } from 'travco-hotel-autocomplete';
import { TravcoFieldLabel } from 'travco-field-label';
import AllocationComponent from './allocation/allocation-container';
import FreesaleComponent from './freesale/freesale-container';
import { forEach } from 'lodash';

class InventorySetup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            freesale: { status: 3 },
            allocation: { status: 3 },
            roomType: null,
            selectedRoomCategory: null,
            roomCategoryOptions: [],
            colWidth: 0
        };
    }

    getAvailableData(row) {

        const rooms = this.props.model.inventory.hotel.roomCategories.find(
            (category) => category.id === this.props.model.inventory.roomCategoryId
        );
        const orderedRoomTypes = InventoryUtils.getRoomTypesSorted(
            row.original.roomInventory.roomTypes,
            rooms.roomTypes
        );
        let available = orderedRoomTypes.map((room) => {
            const freesale = _find(row.original.roomInventory.roomTypesFreesale, { name: room.name });// room.roomInventory.roomTypesFreesale ? room.roomInventory.roomTypesFreesale.find((t) => t.name === room.name) : null;
            const allocation = _find(row.original.roomInventory.roomTypes, { name: room.name }).allotment; // room.roomInventory.roomTypes.find((t) => t.name === room.name).allotment;
            let allotment= `${allocation > 0 ? allocation : 0} ( ${freesale && freesale.allotment > 0 ? freesale.allotment : 0} )`;
            
            return <div className="available-field">{allotment}</div>;
        });

        return available;
    }

    render() {
        const {
            days,
            date,
            overridingDate,
            model: { allocation, freesale, inventory, editIndex, liveAvailabilityList },
            settings,
            isTravcoUser,
            token,
            isUpdatingInventory,
            roomCategoryOptions,
            selectedRoomCategory
        } = this.props;
        let hasLiveAvailability =  typeof liveAvailabilityList != 'undefined';
        let inventoryDataFiltered = inventory.inventoryData
            ? _orderBy(
                  _filter(inventory.inventoryData.allocationByDay, (d) =>
                      moment.tz(d.dateOfAllocation, 'Europe/London').isSameOrAfter(moment.tz('Europe/London'), 'days')
                  ),
                  [ 'dateOfAllocation' ]
              )
            : [];

        return (
            <div className="travco-body">
                <div className="travco-section-wrapper" id="inventory-data-setup">
                    <h2 style={{ marginLeft: '26px',display:'inline-block' }}>
                        {editIndex === -1 && !overridingDate ? 'Create' : 'Update'} Inventory Record
                    </h2>
                    {hasLiveAvailability && (<div style={{ float: 'right', display: 'inline-block' }}>
                        <b style={{ display: 'inline-block', textDecoration: 'underline' }}>  Live Availability </b>
                        {liveAvailabilityList.map(item =>

                            <div>{item}</div>)
                         }
                        
                    </div>
                    )}
                    <div className="travco-flex-content">
                        {!isUpdatingInventory && (
                            <div className="tfc-item">
                                <TravcoHotelAutocomplete
                                    className="hotel-dd"
                                    label="Hotel"
                                    searchable
                                    hotelApiUrl={settings.hotelApiUrl}
                                    selectedHotel={inventory.hotel || null}
                                    onChange={this.props.onHotelChange}
                                    clearable
                                    token={token}
                                    disabled={!_isEmpty(inventory.inventoryData.allocationByDay)}
                                />
                                <div className="room-category-dd">
                                    <TravcoFieldLabel>Room Category</TravcoFieldLabel>
                                    <Select
                                        className="room-category"
                                        name="room-category"
                                        value={selectedRoomCategory}
                                        options={roomCategoryOptions}
                                        onChange={this.props.onRoomCategoryChange}
                                        isDisabled={!_isEmpty(inventory.inventoryData.allocationByDay)}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="tfc-item">
                            <div className="dates-dd">
                                <TravcoDateRangePicker
                                    label="Dates"
                                    startDate={date.from}
                                    endDate={date.to}
                                    onDatesChange={this.props.onDatesChange}
                                    id={'day-date-dates'}
                                    startDateId={'day-date-dates-start'}
                                    endDateId={'day-date-dates-end'}
                                />
                            </div>

                            <div className="days-dd">
                                <TravcoFieldLabel>Week Days</TravcoFieldLabel>
                                <TravcoDaySelector
                                    days={days}
                                    startDate={date.from}
                                    endDate={date.to}
                                    onDayChange={this.props.onDaysChange}
                                    editIndex={editIndex}
                                    id="inventory-date"
                                />
                            </div>
                        </div>

                        {isTravcoUser && (
                            <div className="tfc-item">
                                <AllocationComponent onCheckboxChange={this.props.onCheckboxChange} />
                            </div>
                        )}
                        <div className="tfc-item">
                            <FreesaleComponent onCheckboxChange={this.props.onCheckboxChange} />
                        </div>

                        <div className="tfc-item">
                            <div style={{ margin: '32px 0 16px' }}>
                                <button
                                    id="advanced-booking-add-bt"
                                    className={'btn ' + (editIndex === -1 ? 'btn-primary' : 'btn-success')}
                                    onClick={this.props.onSaveRecord}
                                    disabled={
                                        inventory && inventory.hotel ? (
                                            !inventory.hotel.id ||
                                            !inventory.roomCategoryId ||
                                            !date.from ||
                                            !date.to ||
                                            days === '' ||
                                            (allocation.count == 0 &&
                                                allocation.releaseDays == 0 &&
                                                freesale.count == 0 &&
                                                freesale.releaseDays == 0)
                                        ) : (
                                            true
                                        )
                                    }>
                                    <span
                                        className={
                                            editIndex === -1 ? (
                                                'glyphicon glyphicon-plus-sign'
                                            ) : (
                                                'glyphicon glyphicon-refresh'
                                            )
                                        }
                                    />{' '}
                                    {editIndex === -1 ? 'Add Inventory' : 'Update'}
                                </button>
                                &nbsp;
                                {editIndex !== -1 && (
                                    <button className="btn btn-dark" onClick={this.props.onDiscardRecord}>
                                        Cancel
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div id="inventory-data-table">
                    <h2>Inventory Data</h2>
                    <div className="table-header-wrapper">
                        <div className="table-header-field empty">&nbsp;</div>
                        <div className="table-header-field loaded" style={{ width: this.state.colWidth }}>
                            Loaded
                        </div>
                        <div className="table-header-field available">Available</div>
                    </div>
                    <ReactTable
                        id="inventory-result"
                        loading={false}
                        defaultPageSize={10}
                        data={inventoryDataFiltered}
                        columns={getInventoryTableColumns(this)}
                        style={{ fontSize: '12px', paddingTop: 0 }}
                        SubComponent={(row) => {
                            return (
                                <div className="available-row">
                                    <strong>Maximum</strong>
                                    {[ ...this.getAvailableData(row) ]}
                                    <div className="empty-cell-1" />
                                    <div className="empty-cell-2" />
                                </div>
                            );
                        }}
                        getTrProps={(state, rowInfo) => {
                            if (rowInfo && (rowInfo.index || rowInfo.index === 0) && inventory) {
                                const isDateSelected =
                                    moment(rowInfo.original.dateOfAllocation).isBetween(
                                        this.props.date.from,
                                        this.props.date.to,
                                        'D',
                                        '[]'
                                    ) &&
                                    this.props.days
                                        .split(',')
                                        .includes(moment(rowInfo.original.dateOfAllocation).format('dd'));
                                return {
                                    style: {
                                        background: isDateSelected ? '#6b99c7' : '#ffffff',
                                        color: isDateSelected ? '#ffffff' : '#242424'
                                    }
                                };
                            } else return {};
                        }}>
                        {(state, makeTable) => {
                            let table = document.querySelector('.ReactTable');
                            let cols = table ? table.querySelectorAll('.rt-th') : null;
                            let colWidth = cols ? cols[3].offsetWidth + cols[4].offsetWidth + cols[5].offsetWidth : 0;

                            if (this.state.colWidth !== colWidth) this.setState({ colWidth: colWidth });
                            return makeTable();
                        }}
                    </ReactTable>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    let isTravcoUser =
        state.oidc.user && state.oidc.user.profile ? state.oidc.user.profile['travco_user_type'] === 'Travco' : false;

    let model = {
        ...state.model,
        readOnly: false,
        editIndex: typeof state.model.editIndex === 'undefined' ? -1 : state.model.editIndex
    };

    return {
        token: state.oidc.user !== null ? state.oidc.user.id_token : '',
        settings: state.settings,
        model,
        isTravcoUser
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InventorySetup);
